<template>
  <Loading :loading="loading" class="points row">
    <div v-if="pointsData" class="col-12 col-md-10">
      <h2>My Points</h2>
      <div class="alert alert-success" v-if="upgradeInfo.discount_amount && upgradeInfo.discount_amount > 0">
        Special offer!<br>
        Get {{CurrencyFormatter(upgradeInfo.discount_amount)}} off a membership upgrade.<br>
        {{upgradeInfo.discount_message}}

        <!-- Valid for the next X days. -->
        <!-- TODO wording -->
        <!-- <span v-if="upgradeInfo.discount_hours_remaining">{{upgradeInfo.discount_hours_remaining}} hours only!</span> -->
        <!-- <span v-if="upgradeInfo.discount_days_remaining">{{upgradeInfo.discount_days_remaining}} days!</span> -->
      </div>
      <div v-if="$store.state.auth.memberLevel == 'silver'">
        <p>You currently have {{Math.round(pointsData.total)}} points</p>
        <p>To get the best value from your Cherrytree Membership upgrade to Cherrytree Gold</p>

        <!-- This wasn't right so I've removed it - Simon -->
        <p>You need to earn {{pointsData.remaining}} points, or <router-link :to="{name:'accountGoldUpgrade'}">upgrade now</router-link></p>

        <table v-if="pointsData.history && pointsData.history.length > 0" class="table table-striped">
          <thead>
            <tr>
              <th>Date</th>
              <th>Event</th>
              <th>Points</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(historyItem, index) in pointsData.history"
              :key="index"
              :class="{gold: historyItem.event_type == 'Gold Upgrade'}"
            >
              <td>{{historyItem.created}}</td>
              <td>{{historyItem.event_type}}</td>
              <td>{{Math.round(historyItem.points)}}</td>
              <td>{{Math.round(historyItem.points_balance)}}</td>
            </tr>
            <tr>
              <td colspan="100" class="text-center">Beginning of your points history</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        {{pointsData}}
        <!-- TODO wording no points when gold or more -->
        You can only earn points as a silver member.
      </div>
    </div>
  </Loading>
</template>

<script>
import { fetchUserPoints, fetchUpgradeInfo } from "@/network/userRequests";
import Loading from "@/components/loading/Loading";
import {CurrencyFormatter} from "@/utils";

export default {
  name: "MyReferrals",
  components: {
    Loading
  },
  data() {
    return {
      pointsData: null,
      loading: false,
      upgradeInfo: null
    };
  },
  created() {
    this.loading = true;
    fetchUserPoints(points => {
      this.pointsData = points;
      this.loading = false;
    });
    fetchUpgradeInfo().then(response =>{
        this.upgradeInfo = response;
        this.loading = false;
    }).catch(() =>{
        // console.log("error getting upgrade price")
        this.loading = false;
    })
  },
  computed: {},
  methods: {
    CurrencyFormatter
  }
};
</script>

<style lang="scss" scoped>
.gold {
  font-weight: bold;
}
</style>
